export default {
    created () {
    },
    deactivated () {
    
    },
    data () {
        return {
            uploadHeaders:{'Authorization': 'bearer '+localStorage.getItem(window.consts.strings.userToken)},
            priceTypes: [
                { type: 0, value: "澳币", unit: "澳币", symbol: "$" }, 
                { type: 1, value: "人民币", unit: "元", symbol: "¥"}
            ]
        }
    },
    mounted () {
        
    },
    methods: {
        setPageHead (data) {
            if (this.$store) {
                this.$store.commit('setSysPagerHeader', data)
            }
        },
        setWindowTitle (title) {
            document.title = title ? (title + ' -| 澳尚健康') : '澳尚健康'
        },
        _addToCart (item) {
            return new Promise((resolve, reject) => {
                this.axios.post(window.consts.apis.editShoppingCart, {
                        'commodityId': item.commodityId,
                        'quantity': item.quantity,
                        'editType': 1, //1增加数量，2修改数量
                    })
                    .then(res => {
                        resolve(res)
                    }).catch(e => {
                    reject('出现位置错误')
                })
            })
        },
        _editCart (item) {
            return new Promise((resolve, reject) => {
                this.axios.post(window.consts.apis.editShoppingCart, {
                        'commodityId': item.commodityId,
                        'quantity': item.quantity,
                        'editType': 2, //1增加数量，2修改数量
                    })
                    .then(res => {
                        resolve(res)
                    }).catch(e => {
                    reject('出现位置错误')
                })
            })
        },
        jsonToUrlParams (json) {
            return Object.keys(json).map(function (key) {
                // body...
                return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
            }).join('&')
        },
        setLocalStorage (name, val) {
            localStorage.setItem(name, JSON.stringify(val))
        },
        getLocalStorage (name) {
            return JSON.parse(localStorage.getItem(name))
        },
        deleteLocalStorage (name) {
            localStorage.removeItem(name);
        },
        isArrayFn (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        },
        showPcLoading() {
            this.loading = this.$loading({
                lock: true,
                background: 'rgba(0, 0, 0, 0.3)'
            })
        },
        hidePcLoading() {
            this.loading.close()
        },
        showH5Loading() {
            this.$toast.loading({
                duration: 0,
                forbidClick: true,
                loadingType: 'spinner',
                message: '加载中...'
            });
        },
        hideH5Loading() {
            //console.log(this.loadingH5);
            this.$toast.clear(true)
        },
        beforeRouteLeave(to, from, next) {
            to.meta.keepAlive = true
            next()
        },
        convertNumber(par, reserved, symbol) {
            var reg = /^-?\d+.?\d*$/
            if (reg.test(par)) {
                if (symbol) {
                return par >= 0 ? parseFloat(par) : (reserved || reserved === 0 ? 0 : Number.NaN)
                }
                return parseFloat(par)
            }
            return reserved || reserved === 0 ? 0 : Number.NaN
        },
        // 加减法运算
        operationAddOrSub(symbol, ...values) {
            var result = 0
            var baseNum = 0
            var newValues = []
            var digits = []
            for (var i = 0; i < values.length; i++) {
                var digit
                try {
                digit = values[i].toString().split('.')[1].length
                } catch (e) {
                digit = 0
                }
                digits.push(digit)
            }
            baseNum = Math.pow(10, Math.max.apply(null, digits))
            newValues = values.map(x => x * baseNum)
            try {
                switch (symbol) {
                case '+':
                    result = newValues.reduce((x, y) => x + y) / baseNum
                    break
                case '-':
                    result = newValues.reduce((x, y) => x - y) / baseNum
                    break
                }
            } catch (e) {
                result = 0
            }
            return result
        },
        // 乘法运算
        operationMulti(...values) {
            var result = 0
            var digit = 0
            var newValues = []
            for (var i = 0; i < values.length; i++) {
                try {
                digit += values[i].toString().split('.')[1].length
                } catch (e) {
                digit += 0
                }
            }
            newValues = values.map(x => {
                return this.convertNumber(x.toString().replace('.', ''), 0)
            })
            result = newValues.reduce((x, y) => x * y) / Math.pow(10, digit)
            console.log(result)
            return result
        },
        toFixed(val, dec) {
            let decimal = 2  // 指定四舍五入保留的小数位数，默认2位
            if (dec && !isNaN(dec) && dec >=0) {
                decimal = dec
            }
            let newNum = val
            let arr = val.toString().split('.')
            let zhengshu = arr[0]
            if (arr[1] && arr[1].length > decimal) { //如果有小数切小数位数大于指定位数
                let xiaoshu = arr[1]
                newNum = this.operationAddOrSub('+', zhengshu * Math.pow(10, decimal), xiaoshu.substr(0, decimal))
                if (Number(xiaoshu[decimal]) >= 5) {
                    newNum = newNum + 1
                }
                newNum = newNum /100
            }
            return newNum
        },
        // 转换自提订单状态的文字
        orderStatusTxt(order) {
            let txt = ""
            if (!order) {
                return ""
            }
            if (!order.tenantId) {
                txt = order.statusDesc
            } else {
                if (order.status === 1) {
                    txt = "未支付"
                } else if (order.status === 2) {
                    txt = "已支付"
                } else if (order.status > 2 && order.status < 32) {
                    txt = "已备货"
                } else if (order.status === 32) {
                    txt = "已提货"
                } else if (order.status === -1) {
                    txt = "已取消"
                }
            }
            return txt
        },
        // 根据传递的类型，获取币种对象
        getPriceType(type) {
            type = type || 0
            return this.priceTypes.filter(x => x.type === type)[0]
        },
        // 获取url地址栏参数
        getRequest() {
            var url = location.search // 获取url中含"?"符后的字串
            var theRequest = {}
            if (url.indexOf('?') != -1) {
                var str = url.substr(1)
                var strs = str.split('&')
                for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
                }
            }
            return theRequest
        }
    }
}
